import React from 'react';
import {
  Admin,
  Resource,
  UserMenu,
  Layout,
  AppBar,
} from 'react-admin';
import OfferCampaignIcon from '@material-ui/icons/Email';
import OfferIcon from '@material-ui/icons/LocalOffer';
import OfferDocumentIcon from '@material-ui/icons/LibraryBooks';
import PrivateQuoteIcon from '@material-ui/icons/AttachMoney';
import { MenuItem, ListItemText, ListItemIcon, withStyles } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';

import authProvider, { getUser } from './authProvider';
import dataProvider, { FOLIO_RESOURCES, ACCOUNT_RESOURCES, MAILCHIMP_RESOURCES } from './dataProvider';
import reducers from './reducers';
import fetchErrorSaga from './fetchErrorSaga';
import routes from './routes';

import Login from './components/Login';
import Dashboard from './components/Dashboard';
import * as User from './components/User';
import * as Offer from './components/Offer';
import * as OfferOrder from './components/OfferOrder';
import * as OfferWatch from './components/OfferWatch';
import * as OfferCampaign from './components/OfferCampaign';
import * as OfferDocument from './components/OfferDocument';
import * as PrivateQuote from './components/PrivateQuote';
import * as PushNotification from './components/PushNotification';
import * as PushNotificationRegistration from './components/PushNotificationRegistration';
import * as NewAccounts from './components/NewAccounts';
import * as EmailTemplates from './components/EmailTemplates';
import * as ExternalOfferOrder from './components/ExternalOfferOrder';
import * as SolicitedUsers from './components/SolicitedUsers';
import * as Config from './components/Config';

const styles = () => ({
  root: {
    opacity: '0.9',
  },
  text: {
    paddingLeft: '0px',
  },
});

const LoggedInUser = () => {
  const user = getUser();
  return `${user.email} (${user.role})`;
};

const CustomUserMenu = withStyles(styles)(props => (
  <UserMenu {...props}>
    <MenuItem className={props.classes.root} disabled>
      <ListItemIcon>
        <AccountCircle />
      </ListItemIcon>
      <ListItemText className={props.classes.text} primary={<LoggedInUser />} />
    </MenuItem>
  </UserMenu>
));
const CustomAppBar = props => <AppBar {...props} userMenu={<CustomUserMenu />} />;
const appLayout = props => <Layout {...props} appBar={CustomAppBar} />;

// NOTE: app routes
const App = () => (
  <Admin
    title="My IPO Admin"
    authProvider={authProvider}
    appLayout={appLayout}
    dataProvider={dataProvider}
    loginPage={Login}
    dashboard={Dashboard}
    customReducers={reducers}
    customSagas={[fetchErrorSaga]}
    customRoutes={routes}
  >
    <Resource
      name="configs"
      create={Config.Create}
      edit={Config.Edit}
      list={Config.List}
      show={Config.Show}
      options={{ label: 'Configs' }}
      icon={Config.Icon}
    />
    <Resource
      name="users"
      create={User.Create}
      edit={User.Edit}
      list={User.List}
      show={User.Show}
      options={{ label: 'Users' }}
      icon={User.Icon}
    />
    <Resource
      name="solicitedUsers"
      list={SolicitedUsers.List}
      show={SolicitedUsers.Show}
      edit={SolicitedUsers.Edit}
      options={{ label: 'Solicited Users' }}
      icon={User.Icon}
    />
    <Resource
      name="newAccounts"
      list={NewAccounts.List}
      options={{ label: 'New Accounts' }}
      icon={NewAccounts.Icon}
    />
    <Resource
      name="offerings"
      create={Offer.Create}
      edit={Offer.Edit}
      list={Offer.List}
      show={Offer.Show}
      options={{ label: 'Offers' }}
      icon={OfferIcon}
    />
    <Resource
      name="offeringDocuments"
      create={OfferDocument.Create}
      edit={OfferDocument.Edit}
      list={OfferDocument.List}
      options={{ label: 'Offer Documents' }}
      icon={OfferDocumentIcon}
    />
    <Resource
      name="offeringOrders"
      list={OfferOrder.List}
      show={OfferOrder.Show}
      create={OfferOrder.Create}
      edit={OfferOrder.Edit}
      options={{ label: 'Offer Orders' }}
      icon={OfferOrder.Icon}
    />
    <Resource
      name="externalOfferOrders"
      list={ExternalOfferOrder.List}
      show={ExternalOfferOrder.Show}
      edit={ExternalOfferOrder.Edit}
      options={{ label: 'External Offer Orders' }}
      icon={OfferOrder.Icon}
    />
    <Resource
      name="offeringWatches"
      list={OfferWatch.List}
      show={OfferWatch.Show}
      // create={OfferWatch.Create}
      options={{ label: 'Indications of Interest' }}
      icon={OfferIcon}
    />
    <Resource
      name="emailTemplates"
      list={EmailTemplates.List}
      show={EmailTemplates.Show}
      edit={EmailTemplates.Edit}
      options={{ label: 'Email Templates' }}
      icon={EmailTemplates.Icon}
    />
    <Resource
      name="offeringCampaigns"
      list={OfferCampaign.List}
      show={OfferCampaign.Show}
      edit={OfferCampaign.Edit}
      create={OfferCampaign.Create}
      options={{ label: 'Offer Campaigns' }}
      icon={OfferCampaignIcon}
    />
    <Resource
      name="privateQuotes"
      list={PrivateQuote.List}
      create={PrivateQuote.Create}
      edit={PrivateQuote.Edit}
      options={{ label: 'Private Quotes' }}
      icon={PrivateQuoteIcon}
    />
    <Resource
      name="pushNotifications"
      list={PushNotification.List}
      show={PushNotification.Show}
      create={PushNotification.Create}
      options={{ label: 'Push Notifications' }}
      icon={PushNotification.Icon}
    />
    <Resource
      name="pushNotificationRegistrations"
      list={PushNotificationRegistration.List}
      options={{ label: 'Push Notification Registrations' }}
      icon={PushNotificationRegistration.Icon}
    />

    <Resource name="accounts" />
    <Resource name="userFiles" />
    <Resource name="userRepresentatives" />
    {ACCOUNT_RESOURCES.map(name => <Resource key={name} name={name} />)}
    {FOLIO_RESOURCES.map(name => <Resource key={name} name={name} />)}
    {MAILCHIMP_RESOURCES.map(name => <Resource key={name} name={name} />)}
  </Admin>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js